export class TMnAutonomiaCargoRequest {
    idenT_CARGO: number | null = null;
    idenT_CARGO_SUPERVISOR: number | null = null;
}
